import React from 'react';
import Modal from 'react-modal';
import SupportForm from '../account/forms/supportForm.jsx';

export default ({
  open, closeSupportModal, updateCustomerProfile, customerInfo, orderId,
  orderSupportInfoCommon, orderAssistance, formData, sendSupportMessage
}) =>
    <Modal
      className="Modal__Bootstrap modal-dialog"
      closeTimeoutMS={150}
      isOpen={open}
      contentLabel="Support"
    >
      <div className="modal-content modal-content-padding">
        <div className="modal-header mar-t-5">
          <div className="acct-modal-close-btn">
            <i className='fa fa-times' aria-hidden="true" onClick={closeSupportModal}></i>
          </div>
          <div className="acct-modal-heading">Order Support</div>
          <div className="acct-modal-hr"></div>
        </div>
        <div className="modal-body modal-body-padding" style={{fontSize: "14px"}}>
          <div><strong>Name: </strong>{ `${customerInfo.get('firstname')} ${customerInfo.get('lastname')}` }</div>
          <div><strong>Order ID: </strong>{ `${orderId}` }</div>
          <div className="mar-b-15"><strong>Email: </strong>{ `${customerInfo.get('email')}` }</div>
          <div>
            <SupportForm
              closeSupportModal={closeSupportModal}
              orderAssistance={orderAssistance}
              formData={formData}
              sendSupportMessage={sendSupportMessage}
            />
          </div>
        </div>
      </div>
    </Modal>
